// @flow

import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { pathOr } from "ramda";

import { useI18n } from "@quantum/i18n";

import {
  abrirArquivo,
  abrirPaginaArquivos,
  excluirArquivo,
} from "../../../state";

import Pagina from "../pagina";
import ListaArquivosMedidas from "../lista-arquivos-medidas";

const AbrirArquivo = () => {
  const { translate } = useI18n();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const aoSelecionar = useCallback(
    arquivo => {
      const gerarRelatorio = pathOr(false, ["state", "resultado"], location);
      dispatch(abrirArquivo(arquivo, { gerarRelatorio }));
      if (!gerarRelatorio) history.goBack();
    },
    [dispatch, history, location]
  );

  const aoExcluir = useCallback(arquivo => dispatch(excluirArquivo(arquivo)), [
    dispatch,
  ]);

  const aoCompartilhar = useCallback(
    arquivo => dispatch(abrirPaginaArquivos("COMPARTILHAR", { arquivo })),
    [dispatch]
  );

  return (
    <Pagina titulo={translate("configuracaoRelatorio.hintAbrirArquivo")}>
      <ListaArquivosMedidas
        handleExcluirArquivo={aoExcluir}
        handleSelecionarArquivo={aoSelecionar}
        handleCompartilharArquivo={aoCompartilhar}
      />
    </Pagina>
  );
};

export default AbrirArquivo;
